export const APPLIED_GIFT_CARDS_FRAGMENT = /* GraphQL */ `
  fragment APPLIED_GIFT_CARDS_FRAGMENT on ApplyGiftCardToOrder {
    __typename
    code
    applied_balance {
      value
      currency
    }
  }
`;

export const GIFT_MESSAGE_FRAGMENT = /* GraphQL */ `
  fragment GIFT_MESSAGE_FRAGMENT on GiftMessage {
    __typename
    from
    to
    message
  }
`;

export const GIFT_WRAPPING_FRAGMENT = /* GraphQL */ `
  fragment GIFT_WRAPPING_FRAGMENT on GiftWrapping {
    __typename
    uid
    design
    image {
      url
    }
    price {
      value
      currency
    }
  }
`;
